import { ConditionalTemplateQuestion, ConditionalTemplateQuestion_FieldsFragment } from 'queries';

import Modal from 'common/modal';

import { ConditionalTemplateQuestionForm } from './conditional-template-question-form';

type Props = {
  conditionalTemplateQuestionSetId: string;
  selectedConditionalTemplateQuestion: ConditionalTemplateQuestion_FieldsFragment;
  setSelectedConditionalTemplateQuestion: (value: ConditionalTemplateQuestion | undefined) => void;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export const EditConditionalTemplateQuestionModal = ({
  conditionalTemplateQuestionSetId,
  selectedConditionalTemplateQuestion,
  setSelectedConditionalTemplateQuestion,
  setShowModal,
  showModal,
}: Props) => {
  const onExitClick = () => {
    setShowModal(false);
    setSelectedConditionalTemplateQuestion(undefined);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <ConditionalTemplateQuestionForm
          conditionalTemplateQuestionSetId={conditionalTemplateQuestionSetId}
          isEditing={true}
          selectedConditionalTemplateQuestion={selectedConditionalTemplateQuestion}
          onExitClick={onExitClick}
        />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="xl"
    />
  );
};
